import React from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionGlImpact } from "../../../api/transaction-type";
import { currencyRevaluationGlImpactTable } from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";

export default function ItemsFulfillmentGlImpact({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  async function getTransactionDocGlImpactData(limit, offset) {
    try {
      const { data } = await getTransactionGlImpact(user.token, { id: params.docNo,
        limit, offset,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      //setLoading(false);
    }
  }

  return (
    <>
      {tabIndexP === 7 ? (
        <AgGridPaginatedTable
          getTableRows={getTransactionDocGlImpactData}
          columns={currencyRevaluationGlImpactTable}
          perPage={5}
          refreshCounter={0}
        />
      ) : (
        <></>
      )}
    </>
  );
}
